import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Card, CardContent, Typography, Stack } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import moment from 'moment';

const ShiftActionCards = ({
  shiftEndTime,
  shiftStartTime,
  onAddPatrol,
  onDuplicateShift,
}) => {
  return (
    <Stack spacing={2} sx={{ mt: 2 }}>
      {/* Add Patrol Card Button */}
      <Card
        elevation={0}
        onClick={onAddPatrol}
        sx={{
          border: '2px dashed',
          borderColor: 'divider',
          backgroundColor: 'transparent',
          cursor: 'pointer',
          transition: 'all 0.2s ease-in-out',
          '&:hover': {
            borderColor: 'primary.main',
            backgroundColor: 'action.hover',
          },
        }}
      >
        <CardContent
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            py: 3,
          }}
        >
          <AddIcon sx={{ fontSize: 32, color: 'text.secondary', mb: 1 }} />
          <Typography variant="body2" sx={{ color: 'text.secondary', fontWeight: 500 }}>
            Add Patrol to Shift
          </Typography>
          <Typography variant="caption" sx={{ color: 'text.disabled', mt: 0.5 }}>
            Continues from {moment(shiftEndTime).format('h:mm A')}
          </Typography>
        </CardContent>
      </Card>

      {/* Duplicate Shift to Next Day Button */}
      <Card
        elevation={0}
        onClick={onDuplicateShift}
        sx={{
          border: '2px dashed',
          borderColor: 'divider',
          backgroundColor: 'transparent',
          cursor: 'pointer',
          transition: 'all 0.2s ease-in-out',
          '&:hover': {
            borderColor: 'secondary.main',
            backgroundColor: 'action.hover',
          },
        }}
      >
        <CardContent
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            py: 3,
          }}
        >
          <ContentCopyIcon sx={{ fontSize: 32, color: 'text.secondary', mb: 1 }} />
          <Typography variant="body2" sx={{ color: 'text.secondary', fontWeight: 500 }}>
            Duplicate to Next Day
          </Typography>
          <Typography variant="caption" sx={{ color: 'text.disabled', mt: 0.5 }}>
            Copy all patrols to {moment(shiftStartTime).add(1, 'day').format('ddd, MMM D')}
          </Typography>
        </CardContent>
      </Card>
    </Stack>
  );
};

ShiftActionCards.propTypes = {
  shiftEndTime: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]).isRequired,
  shiftStartTime: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]).isRequired,
  onAddPatrol: PropTypes.func,
  onDuplicateShift: PropTypes.func,
};

export default memo(ShiftActionCards);
